import { useEffect, useState } from 'react'
import { useOutletContext, useNavigate, useSearchParams } from 'react-router-dom'

import { useTranslation } from '@utils/i18n/i18n'
import { forgotPasswordConfirmByEmail, setNewPasswordByEmail } from '@services/auth.service'

import './reset-password-form.styl'

function ResetPasswordForm() {
  const { setChangedPasswordMessage } = useOutletContext()
  const [searchParams] = useSearchParams()
  const username = searchParams.get('username')
  const temp = searchParams.get('temp')
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [errorMessage, setErrorMessage] = useState()
  const [forgotPasswordCode, setForgotPasswordCode] = useState(temp || '')
  const [newPassword, setNewPassword] = useState('')
  const [repeatedNewPassword, setRepeatedNewPassword] = useState('')
  const [email] = useState(username || localStorage.getItem('forgotPasswordEmail') || '')

  useEffect(() => {
    if (newPassword && repeatedNewPassword && newPassword !== repeatedNewPassword) {
      setErrorMessage(t('new_password_not_equal_to_repeated_new_password'))
    } else {
      setErrorMessage('')
    }
  }, [newPassword, repeatedNewPassword, t])

  const onSubmit = async (e) => {
    e.preventDefault()

    try {
      if (username) {
        await setNewPasswordByEmail(email, forgotPasswordCode, newPassword)
      } else {
        await forgotPasswordConfirmByEmail(email, forgotPasswordCode, newPassword)
      }
      setChangedPasswordMessage(t('update_password_success'))
      navigate('/login')
    } catch (err) {
      setErrorMessage(err?.response?.data?.message || 'Something went wrong confirming new password')
    }
  }

  return (
    <form className="reset-password-form" onSubmit={onSubmit}>
      <h1 className="reset-password-form__title">Reset password</h1>
      <p className="reset-password-form__intro">
        Enter the email address linked to your account, and we&apos;ll send you info on how to reset your password.
      </p>

      <div className="reset-password-form__inputs">
        <div className="reset-password-form__inputs__field">
          <input
            onChange={e => setForgotPasswordCode(e.target.value)}
            placeholder="Password reset code"
            type="text"
            value={forgotPasswordCode}
          />
        </div>
        <div className="reset-password-form__inputs__field">
          <input
            type="password"
            placeholder="New Password"
            autoComplete="new-password"
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value)
            }}
            required
          />
        </div>
        <div className="reset-password-form__inputs__field">
          <input
            type="password"
            placeholder="Repeat new Password"
            autoComplete="new-password"
            value={repeatedNewPassword}
            onChange={(e) => {
              setRepeatedNewPassword(e.target.value)
            }}
            required
          />
        </div>
      </div>

      {errorMessage && (
        <div className="reset-password-form__error">
          {errorMessage}
        </div>
      )}

      <button
        type="submit"
        className="reset-password-form__submit"
        disabled={repeatedNewPassword !== newPassword}
      >
        <span>Submit</span>
      </button>

      <button
        type="button"
        className="reset-password-form__return-link"
        onClick={() => navigate('/login')}
      >
        <span>Return to sign in</span>
      </button>
    </form>
  )
}

export default ResetPasswordForm
